module.exports = __webpack_public_path__ + "c534f1d49a1c955766eadc62e9f3cabc.png";